const productTypeScale = [
  '#4B4EFC',
  '#9B9DFD',
  '#C3C4FE',
  '#02058d',
  '#0408e7',
  '#7375fd',
  '#e1e1fe',
  '#0306ba',
  '#1e22fb',
  '#f5f5ff',
];

const deductionPair = ['#4B4EFC', '#A5B4FC'];

export const requestPerStatus = {
  key: 'request_per_status',
  label: 'Requests Per Status',
  backgroundColor: ['#22C55E', '#EF4444', '#F59E0B', '#111827'],
  type: 'doughnut',
};

export const statusPerType = {
  key: 'projects_per_status',
  label: 'Status Per Type',
  backgroundColor: ['#4B4EFC', '#F59E0B', '#EF4444', '#22C55E'],
  type: 'doughnut',
};

export const typesOfProducts = {
  key: 'projects_per_type',
  label: 'Types Of Products',
  backgroundColor: productTypeScale,
  type: 'doughnut',
};

export const completionDuration = {
  key: 'completion_duration',
  label: 'Average Completion Duration',
  backgroundColor: ['#6366F1', '#C7D2FE'],
  type: 'line',
};

export const currentPendingTasksPerAssignee = {
  key: 'current_pending_tasks_per_assignee',
  label: 'Current Pending Tasks Per Assignee',
  backgroundColor: productTypeScale,
  type: 'doughnut',
};

export const completedRequestsOnTimeVsDelayed = {
  key: 'completed_vs_delayed_requests',
  label: 'Completed Requests On-Time vs Delayed',
  backgroundColor: ['#22C55E', '#EF4444'],
  type: 'doughnut',
};

export const vendorStatusPerCategory = {
  key: 'vendors_per_status',
  label: 'Vendor Status Per Category',
  backgroundColor: [
    '#4B4EFC',
    '#F59E0B',
    '#B45309',
    '#22C55E',
    '#EF4444',
    '#6b7280',
  ],
  type: 'doughnut',
};

export const typesOfVendors = {
  key: 'vendors_per_category',
  label: 'Types Of Vendors',
  backgroundColor: productTypeScale,
  type: 'doughnut',
};

export const deductionOnAdvance = {
  key: 'on_advance',
  label: 'On Advance',
  backgroundColor: deductionPair,
  type: 'doughnut',
};

export const vendorDeductionOnAdvance = {
  key: 'on_advance',
  label: 'On Advance',
  backgroundColor: ['#1f7249', '#a4c7b3'],
  type: 'doughnut',
};

export const vendorDeductionRetention = {
  key: 'retention',
  label: 'Retention',
  backgroundColor: ['#1f7249', '#a4c7b3'],
  type: 'doughnut',
};

export const vendorDeductionPerformance = {
  key: 'performance',
  label: 'Performance',
  backgroundColor: ['#1f7249', '#a4c7b3'],
  type: 'doughnut',
};

export const vendorDeductionOther = {
  key: 'other',
  label: 'Other',
  backgroundColor: ['#1f7249', '#a4c7b3'],
  type: 'doughnut',
};

export const VendorDeductionReports = [
  vendorDeductionOnAdvance,
  vendorDeductionRetention,
  vendorDeductionPerformance,
  vendorDeductionOther,
];

export const deductionRetention = {
  key: 'retention',
  label: 'Retention',
  backgroundColor: deductionPair,
  type: 'doughnut',
};

export const deductionPerformance = {
  key: 'performance',
  label: 'Performance',
  backgroundColor: deductionPair,
  type: 'doughnut',
};

export const deductionOther = {
  key: 'other',
  label: 'Other',
  backgroundColor: deductionPair,
  type: 'doughnut',
};

export const invoicePaymentsStatus = {
  key: 'payments_status',
  label: 'Invoice Payments Status',
  backgroundColor: ['#22C55E', '#4B4EFC', '#F59E0B'],
  type: 'doughnut',
};

export const borrowingAcquisitionChart = {
  key: 'borrowing-acquisition-chart',
  label: 'borrowing_chart_limit_label',
  backgroundColor: ['#EF4444', '#22C55E'],
  type: 'doughnut',
};

export const borrowingDevelopmentChart = {
  key: 'borrowing-development-chart',
  label: 'borrowing_chart_limit_label',
  backgroundColor: ['#EF4444', '#22C55E'],
  type: 'doughnut',
};

export const borrowingTotalLimitChart = {
  key: 'borrowing-total-limit-chart',
  label: 'borrowing_chart_total_label',
  backgroundColor: ['#EF4444', '#22C55E'],
  type: 'doughnut',
};

export const SystemReports = [
  requestPerStatus,
  completionDuration,
  currentPendingTasksPerAssignee,
  completedRequestsOnTimeVsDelayed,
  typesOfProducts,
  statusPerType,
  typesOfVendors,
  vendorStatusPerCategory,
  deductionOnAdvance,
  deductionRetention,
  deductionPerformance,
  deductionOther,
  invoicePaymentsStatus,
];

export const completionDurationRangeFilterOptions: {
  label: string;
  value: string;
}[] = [
  { label: 'This Week', value: 'this_week' },
  { label: 'Last Week', value: 'last_week' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'This Quarter', value: 'this_quarter' },
  { label: 'Last Quarter', value: 'last_quarter' },
  { label: 'Last 30 Days', value: 'last_30_days' },
  { label: 'Last 180 Days', value: 'last_180_days' },
  { label: 'This Year', value: 'this_year' },
  { label: 'Last Year', value: 'last_year' },
];

export const defaultRangeFilterOptions: { label: string; value: string }[] = [
  { label: 'All The Time', value: 'all' },
  { label: 'This Week', value: 'this_week' },
  { label: 'Last Week', value: 'last_week' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'This Quarter', value: 'this_quarter' },
  { label: 'Last Quarter', value: 'last_quarter' },
  { label: 'Last 30 Days', value: 'last_30_days' },
  { label: 'Last 180 Days', value: 'last_180_days' },
  { label: 'This Year', value: 'this_year' },
  { label: 'Last Year', value: 'last_year' },
];
